/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import view from './live-video-player.stache';
import BaseWidget from 'scripts/base-widget';
import 'components/live-video-pop-out/live-video-player/live-video-player';
import can from 'can';

export const liveVideoPlayer = BaseWidget.extend({
    init: function () {
        this.viewModel = new can.Map();
        this.view = view;
        this._super();
    }
});
